import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { ImagenesSatelitalesState } from './types'

export const getters: GetterTree<ImagenesSatelitalesState, RootState> = {
  getImagenesSatelitales (state: ImagenesSatelitalesState) {
    return state
  }
}
